
import { Vue, Component, Prop } from "vue-property-decorator";
import StaticsCount from "./statics-count.vue";
import StaticsScale from "./statics-scale.vue";

@Component({
  components: {
    StaticsCount,
    StaticsScale,
  },
})
export default class StaticsContent extends Vue {
  @Prop({ type: String, default: "all" }) sourceType!: string;
}
